export enum SubscriptionStatus {
  Draft = "DRAFT", // Created local entry, but have not created on Stripe side yet
  Subscribed = "SUBSCRIBED", // Subscription is active on Stripe side
  Canceled = "CANCELED", // Subscription is canceled on Stripe side
  PaymentFailed = "PAYMENT_FAILED", // Unable to charge
}
